import Vue from 'vue'
import Vuex from 'vuex'

import config from '@/store/modules/config'
import credentials from '@/store/modules/credentials'
import clientes from '@/store/modules/clientes'
import polizas from '@/store/modules/polizas'
import siniestros from '@/store/modules/siniestros'
import proyectos from '@/store/modules/proyectos'
import avisos from '@/store/modules/avisos'
import recibos from '@/store/modules/recibos'
import telefonosAsistencia from '@/store/modules/telefonosAsistencia'
import _ from 'lodash'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    config,
    credentials,
    clientes,
    polizas,
    proyectos,
    siniestros,
    avisos,
    telefonosAsistencia,
    recibos
  }
});

export default store;
